// extracted by mini-css-extract-plugin
export default {"createAccount":"CreateAccount_createAccount__jo2eo","existingAccountText":"CreateAccount_existingAccountText__m8Pkh","existingAccountLink":"CreateAccount_existingAccountLink__Xsdgi"};